module.exports = __webpack_public_path__ + "static/media/Logo-datazip.45386b91.svg";